// extracted by mini-css-extract-plugin
export default {"Wrapper":"SurveyRecordsView_Wrapper__QEh+U"};